import MButton from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";

import { StylesProps } from ".";

export const StyledButton = styled(MButton, { name: "AppButton" })((props: StylesProps) => {
  const { background = {}, border = {}, text = {} } = props || {};
  const hasBorder = Boolean(border.color);

  return {
    backgroundColor: background.color || "transparent",
    borderColor: border.color,
    color: text.color || "#FFFFFF",
    borderStyle: hasBorder ? "solid !important" : undefined,
    borderWidth: hasBorder ? "1px !important" : undefined,
    fontFamily: "Inter",
    fontSize: "12px",
    fontStyle: "normal",
    lineHeight: "15px",
    height: "40px",
    borderRadius: "8px",
    textTransform: "none",
    fontWeight: 700,
    padding: "9px 16px",
    "& .MuiButton-startIcon": {
      marginLeft: 0,
    },
    "&:focus": {
      borderStyle: hasBorder ? "solid !important" : undefined,
      borderWidth: hasBorder ? "1px !important" : undefined,
    },
    "&:hover": {
      backgroundColor: background.hoverColor
        ? `${background.hoverColor} !important`
        : "transparent !important",
      borderColor: border.hoverColor,
      color: text.hoverColor ? `${text.hoverColor} !important` : "#FFFFFF !important",
    },
    "&:active": {
      backgroundColor: background.activeColor || "transparent !important",
      borderColor: border.activeColor,
      color: text.activeColor || "#FFFFFF !important",
    },
    "&:disabled": {
      backgroundColor: background.disabledColor
        ? `${background.disabledColor} !important`
        : "transparent !important",
      borderColor: border.disabledColor,
      color: text.disabledColor ? `${text.disabledColor} !important` : "#667085 !important",
      opacity: 0.5,
    },
  };
});

export const CircularProgressStyled = styled(CircularProgress)<{ customColor?: string }>(
  (props) => ({
    color: props.customColor || "#FFFFFF",
  })
);

const useButtonStyles = makeStyles(() => ({
  circularProgress: {
    color: "#FFFFFF",
  },
  ghost: {
    "& .MuiTouchRipple-root": {
      display: "none",
    },
  },
}));

export default useButtonStyles;
